function isPlainObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}
/**
 * 动态拼接各种形式的class表达式
 */
export default function classNames(...c) {
  const rapper = [];
  c.forEach(item => {
    if (!item) return void 0;
    if (typeof item === 'string') {
      rapper.push(item);
    }
    if (isPlainObject(item)) {
      Object.keys(item).forEach(iKey => {
        if (item[iKey]) {
          rapper.push(iKey);
        }
      });
    }
    if (Array.isArray(item)) {
      rapper.push(classNames(...item));
    }
  });
  const result = rapper.filter(item => item).join(' ');
  return result;
}
//# sourceMappingURL=classNames.js.map
